// Key for storing pending updates in localStorage
export const PENDING_UPDATES_KEY = 'srs-pending-updates';
